import { Card } from "@/components/ui/card";
import { cn } from "@/utils/utils";

interface Props {
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const DashboardTile = ({
  children,
  className,
  style,
  onClick,
}: Props) => {
  return (
    <Card
      className={cn("h-full rounded bg-[#0a0a0a] p-6", className)}
      style={style}
      onClick={onClick}
    >
      {children}
    </Card>
  );
};
